import React, { useEffect, useMemo, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import FilterDispatch from '../../contexts/filterDispatch';
import filterActions from '../../actions/filter.actions';

import Checkbox from './Checkbox';
import style from './Archive.module.css';

const Archive = React.memo(
  ({ history, archivedDefault = false, unarchivedDefault = false }) => {
    const params = useMemo(() => new URLSearchParams(history.location.search), [history.location.search]);

    const queryArchived = params.get('archived');
    const queryUnarchived = params.get('unarchived');

    const [archived, setArchived] = useState(queryArchived !== null ? queryArchived === 'true' : archivedDefault);
    const [unarchived, setUnarchived] = useState(queryUnarchived !== null ? queryUnarchived === 'true' : unarchivedDefault);
    const [search, setSearch] = useState(false);

    const dispatch = useContext(FilterDispatch);

    useEffect(() => {
      if (search) {
        params.set('archived', archived);
        params.set('unarchived', unarchived);
        params.set('page', 0);

        history.push(`${history.location.pathname}?${params.toString()}`);
        setSearch(false);

        dispatch({
          type: filterActions.FILTER_CHANGED_SUCCESS,
        });
      }
    }, [search, params, archived, unarchived, dispatch, history]);

    const handleArchivedChange = () => {
      setArchived(!archived);
      setSearch(true);
    };

    const handleUnrchivedChange = () => {
      setUnarchived(!unarchived);
      setSearch(true);
    };

    return (
      <section className={style.archiveBox}>
        <div className={style.archive}>
          <Checkbox onChange={handleArchivedChange} checked={archived} />
          <span className={style.label}>Show Archived Clients</span>
        </div>
        <div className={style.unarchive}>
          <Checkbox onChange={handleUnrchivedChange} checked={unarchived} />
          <span className={style.label}>Show Unarchived Clients</span>
        </div>
      </section>
    );
  },
);

Archive.propTypes = {
  archivedDefault: PropTypes.bool,
  unarchivedDefault: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
};

export default Archive;
